














































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Content, ContentTab, ContentItem, ScrollObject } from '@/models/HorizontalContentScroller';

@Component
export default class InspirationListing extends Vue {
    protected content!: Content;
    protected title!: string;
    protected scrollStartPosition: number = 0;
    protected scrollEndPosition: number = 1000;
    protected scrollObject: ScrollObject = {
        ViewWidth: 1000,
        Gap: 10,
        Position: 0,
        Width: 500,
        Id: '',
        Target: 0,
        ScrollWidth: 0
    };
    protected eventListenersSet: Boolean = false;
    protected isTouchDevice: Boolean = false;
    protected compInstance: number = 0;
    @Prop()
    protected enviroments!: string;

    protected enviromentsParsed!: Array<any>;

    constructor() {
        super();
        if (this.$attrs['data-content']) {
            this.content = JSON.parse(this.$attrs['data-content']);
            this.title = this.$attrs['data-title'];
            this.$attrs['data-content'] = '';

            if (this.content && this.content.Tabs) {
                this.content.Tabs.forEach(tab => {
                if (tab.Items && tab.Items.length > 0) {
                    tab.Items = this.optimizeGridItems(tab.Items);
                }
            });
        }
        } else if (this.enviroments) {
            const rawParsed = JSON.parse(this.enviroments);
            this.enviromentsParsed = this.optimizeGridItems(rawParsed);
        }
    }
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    mounted() {
        if (this.$vnode.componentInstance) {
            this.compInstance = (this.$vnode.componentInstance as any)._uid;
        }
        this.observeScroll();
        setTimeout(this.setScrollObject, 1000);
    }
    

    private getImageRatio(htmlString: string): 'landscape' | 'portrait' {
        if (!htmlString) return 'landscape'; // Default fallback
        const match = htmlString.match(/data-ratio-text=['"]([^'"]+)['"]/);
        return match && match[1] === 'portrait' ? 'portrait' : 'landscape';
    }

    private optimizeGridItems(items: Array<any>): Array<any> {
        const optimizedList: Array<any> = [];
        const chunkSize = 4;

        for (let i = 0; i < items.length; i += chunkSize) {
            const chunk = items.slice(i, i + chunkSize);
            const portraits = chunk.filter(item => this.getImageRatio(item.image) === 'portrait');
            const landscapes = chunk.filter(item => this.getImageRatio(item.image) === 'landscape');

            const reorderedChunk = [];

            for (let j = 0; j < chunk.length; j++) {
                if (j === 3) {
                    if (portraits.length > 0) {
                        reorderedChunk.push(portraits.shift());
                    } else {
                        reorderedChunk.push(landscapes.shift()); 
                    }
                } else {
                    if (landscapes.length > 0) {
                        reorderedChunk.push(landscapes.shift());
                    } else {
                        reorderedChunk.push(portraits.shift());
                    }
                }
            }

            optimizedList.push(...reorderedChunk);
        }

        return optimizedList;
    }

    private optimizeGridItemsAll(items: Array<any>): Array<any> {
        const portraits = items.filter(item => this.getImageRatio(item.image) === 'portrait');
        const landscapes = items.filter(item => this.getImageRatio(item.image) === 'landscape');
        const optimizedList: Array<any> = [];
        const totalItems = items.length;

        for (let i = 0; i < totalItems; i++) {
            const isPortraitSlot = (i + 1) % 4 === 0;

            if (isPortraitSlot) {
                if (portraits.length > 0) {
                    optimizedList.push(portraits.shift());
                } else if (landscapes.length > 0) {
                    optimizedList.push(landscapes.shift());
                }
            } else {
                if (landscapes.length > 0) {
                    optimizedList.push(landscapes.shift());
                } else if (portraits.length > 0) {
                    optimizedList.push(portraits.shift());
                }
            }
        }

        return optimizedList;
    }

    private scrollObserver: IntersectionObserver | null = null;

    private observeScroll() {
        const topElement = this.$refs.topRef as HTMLElement;
        if (!topElement) return;

        const mediaQuery = window.matchMedia('(min-width: 1300px)');

        const initObserver = (isLargeScreen: boolean) => {
            if (this.scrollObserver) {
                this.scrollObserver.disconnect();
            }

            const topMargin = isLargeScreen ? '-81px' : '-56px';

            this.scrollObserver = new IntersectionObserver(
                ([entry]) => {
                    entry.target.classList.toggle('is-stuck', entry.intersectionRatio < 1);
                },
                { 
                    threshold: [1],
                    rootMargin: `${topMargin} 0px 0px 0px` 
                }
            );

            this.scrollObserver.observe(topElement);
        };

        initObserver(mediaQuery.matches);

        mediaQuery.addEventListener('change', (event) => {
            initObserver(event.matches);
        });
    }

    private isNextActive() {
        return Math.abs(this.scrollObject.Position - this.scrollObject.Width) > 2;
    }
    private isBackActive() {
        return this.scrollObject.Position !== 0;
    }

    private selectedTab() {
        if (!this.content) return null;
        const selectedTab = this.content.Tabs.filter(row => row.Selected);
        if (selectedTab === null || selectedTab === undefined || selectedTab.length === 0) {
            // @ts-ignore
            console.log('No tab has prop Selected = True');
        }
        return selectedTab;
    }

    private changeTab(tab: number) {
        this.content.Tabs.forEach(element => {
            element.Selected = false;
        });

        this.content.Tabs[tab].Selected = true;

        setTimeout(this.setScrollObject, 1000);
    }

    private setScrollObject() {
        // @ts-ignore
        const scrollObject: ScrollObject = {};

        let ulId = '';
        if (this.content) {
            const tab = this.selectedTab();
            if (tab != null && tab.length > 0) {
                ulId = '#scroll-list-' + this.compInstance + '-' + tab[0].Id;
            }
        } else {
            ulId = '#scroll-list-' + this.compInstance;
        }
        scrollObject.Id = ulId;
        const ul = document.querySelector(ulId);

        if (ul != null) {
            const styles = window.getComputedStyle(ul);
            const columnGap = Number(styles.getPropertyValue('grid-column-gap').replace('px', ''));
            scrollObject.Gap = columnGap;
            // @ts-ignore
            scrollObject.Width = ul.scrollWidth - ul.offsetWidth;
            // @ts-ignore
            scrollObject.ViewWidth = ul.offsetWidth;
            scrollObject.Position = Math.floor(ul.scrollLeft);
            scrollObject.Target = this.scrollObject.Target;
        }

        this.scrollObject = scrollObject;
    }
    private handleScroll(event: any) {
        this.setScrollObject();
    }

    private scroll(ev: PointerEvent, adjust: number) {
        this.setScrollObject();
        const el = ev.target as HTMLElement;
        const parent = el.closest('.inspiration-listing');
        if (parent) {
            const ul = parent.querySelector('.inspiration-list');
            if (ul != null) {
                this.scrollObject.Target =
                    this.scrollObject.Position + (this.scrollObject.ViewWidth + this.scrollObject.Gap) * adjust;

                ul.scrollTo({
                    left: this.scrollObject.Target,
                    behavior: 'smooth'
                });
                // @ts-ignore
                ul.onscroll = e => {
                    // @ts-ignore
                    if (
                        ul != null &&
                        (ul.scrollLeft === this.scrollObject.Target ||
                            ul.scrollLeft === this.scrollObject.Width ||
                            (ul.scrollLeft === 0 && this.scrollObject.Target < 0))
                    ) {
                        this.setScrollObject();
                        // @ts-ignore
                        ul.onscroll = null;
                    }
                };
            }
        }
    }
}
